export default __webpack_public_path__ + "static/2-1dc3ddba5fb6fceea18165e5f752cae4.png";